import BaseConfig from 'general/constants/DomainConfig'
import { createContext, useContext, useEffect, useState } from 'react'

const HostnameContext = createContext()

export function HostnameProvider({ children }) {
  const [hostname, setHostname] = useState('')

  useEffect(() => {
    let realHostname = window.location.hostname
    if (!Object.keys(BaseConfig).includes(realHostname))
      realHostname = 'tracuuhoadon.vietinvoice.vn'
    setHostname(realHostname) // Lấy hostname khi mở web
  }, [])

  return (
    <HostnameContext.Provider value={hostname}>
      {children}
    </HostnameContext.Provider>
  )
}

export function useHostname() {
  return useContext(HostnameContext)
}
